module.exports = __webpack_public_path__ + "static/delivery-man-322e2b64e138ad5cb9d19a240bfcf92c.png";